import EditorFieldOptionBase from './EditorFieldOptionBase';
import styled from 'foundations-theming/utils';
export default styled(EditorFieldOptionBase)(({
  theme,
  disabled
}) => ({
  '&&&': {
    cursor: disabled ? 'not-allowed' : undefined,
    color: disabled ? theme.color['text-primary-disabled'] : undefined,
    paddingRight: theme.space[500],
    '&:hover, &:active, &:focus': {
      textDecoration: disabled ? 'none' : 'underline',
      backgroundColor: disabled ? 'transparent' : undefined
    }
  }
}));